var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02631IconServiceLogicApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba6b54e9-66d7-42e0-a289-95171eaf47f3",
    x1: 9,
    y1: 1.796,
    x2: 9,
    y2: 6.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cebff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50e6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e5c23c93-889c-4cfe-8adf-72bfa2a5b6e4",
    x1: 3.374,
    y1: 12.14,
    x2: 3.374,
    y2: 18.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#b4ec36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86d633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb46250a-f4a9-418f-b6ae-1a568665f153",
    x1: 14.626,
    y1: 12.14,
    x2: 14.626,
    y2: 18.457,
    gradientTransform: "translate(-0.02 29.273) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#b4ec36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86d633"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a9693b19-30a4-439f-a536-87fc73c5ba8c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.851,9.047H10.939A1.518,1.518,0,0,1,9.421,7.529V4.33H8.579v3.2A1.518,1.518,0,0,1,7.061,9.047H4.149a1.2,1.2,0,0,0-1.2,1.2v2.338h.841V10.244a.355.355,0,0,1,.356-.355H7.061A2.353,2.353,0,0,0,8.8,9.125a.278.278,0,0,1,.408,0,2.353,2.353,0,0,0,1.735.764h2.912a.354.354,0,0,1,.355.355v2.338h.841V10.244A1.2,1.2,0,0,0,13.851,9.047Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.626,
    y: -0.02,
    width: 6.747,
    height: 6.747,
    rx: 0.604,
    fill: "url(#ba6b54e9-66d7-42e0-a289-95171eaf47f3)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.273,
    width: 6.747,
    height: 6.747,
    rx: 0.604,
    fill: "url(#e5c23c93-889c-4cfe-8adf-72bfa2a5b6e4)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.253,
    y: 11.273,
    width: 6.747,
    height: 6.747,
    rx: 0.604,
    transform: "translate(29.273 0.02) rotate(90)",
    fill: "url(#fb46250a-f4a9-418f-b6ae-1a568665f153)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02631IconServiceLogicApps);
export default __webpack_public_path__ + "static/media/02631-icon-service-Logic-Apps.41cd269848607a1d53f6e1a8b1111dc4.svg";
export { ForwardRef as ReactComponent };